import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sa-unauth-view',
  templateUrl: './sa-unauth-view.component.html',
  styleUrls: ['./sa-unauth-view.component.scss']
})
export class SaUnauthViewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
